/**
 * PR-D2 (ADR-0040) — единый pure-helper расчёта суммы аванса из хранимой
 * ставки «Аванс, %».
 *
 * Используется КП (`SectionConditions`, `renderQuoteToPdf`), Договором
 * (`contractSelectors`, `SectionCostAndTerms`, `renderContractToPdf`) и
 * маппингом КП→Договор (`quoteToContractMapping`). Единственная реализация
 * во избежание расходящегося дублирования (A.4 — homogeneous pattern).
 *
 * Модель (Вариант A, ADR-0040):
 *   - `percent` задан валидным числом 0–100 → сумма аванса = производное
 *     `round(total × percent / 100)` (`percent = 0` → 0, валидно).
 *   - `percent` = `null`/`undefined`/вне диапазона/NaN → ручной режим:
 *     возвращается `manualAmount` (введённая руками сумма).
 *
 * Хранится ТОЛЬКО ставка; сумма не персистится отдельно — пересчитывается из
 * текущей стоимости (нет рассинхрона при изменении стоимости).
 */
export function resolveAdvanceAmount(
  total: number,
  percent: number | null | undefined,
  manualAmount: number,
): number {
  if (percent != null && Number.isFinite(percent) && percent >= 0 && percent <= 100) {
    return Math.round((total * percent) / 100);
  }
  return manualAmount;
}

/**
 * Активен ли %-режим (ставка задана валидным числом 0–100). Используется UI
 * для решения read-only/auto поля суммы аванса.
 */
export function isAdvancePercentMode(percent: number | null | undefined): boolean {
  return percent != null && Number.isFinite(percent) && percent >= 0 && percent <= 100;
}
